// extracted by mini-css-extract-plugin
export default {"hidden":"index_hidden__ZUYCP","previewModalImage":"index_previewModalImage__j72dX","image":"index_image__x-AuM"};